import React, { useState, useEffect, useRef } from 'react';
import './NewInsuranceOption.scss';
import EditIcon from 'src/assets/icons/editlogo.svg';
import Input from 'src/components/base/Input/Input';
import { useTranslation } from 'react-i18next';

interface Props {
  insuranceTitle: string;
  onChange?: (val: string) => void;
}

const NewInsuranceOption: React.FC<Props> = ({ insuranceTitle, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(insuranceTitle);

  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('components');

  useEffect(() => {
    setValue(insuranceTitle);
  }, [insuranceTitle]);

  const isValid = value.trim().length > 0;

  const handleSave = () => {
    const trimmed = value.trim();

    if (!trimmed) return;

    setValue(trimmed);
    setIsEditing(false);
    onChange?.(trimmed);
  };

  const handleCancel = () => {
    setValue(insuranceTitle);
    setIsEditing(false);
  };

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        handleCancel();
      }
    }

    if (isEditing) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isEditing]);

  return (
    <div className="new-insurance-option-container">
      <div className="new-insurance-option-title text-start">
        <span className="me-1">
          {t('insuranceManagementTodo.ReviewInsurance.headerText')}
        </span>
        {!isEditing ? (
          <span className="value-container">
            <span className="color-black insurance-value">{value}</span>

            <img
              src={EditIcon}
              alt={t('insuranceManagementTodo.ReviewInsurance.edit')}
              className="insurance-title-edit-icon ms-2"
              onClick={() => setIsEditing(true)}
            />
          </span>
        ) : (
          <div className="value-container" ref={containerRef}>
            <Input
              value={value}
              onChange={(e: any) => setValue(e.target.value)}
              isForForm={false}
              className="insurance-title"
              onKeyDown={(e: any) => {
                if (e.key === 'Enter' && isValid) handleSave();
                if (e.key === 'Escape') handleCancel();
              }}
            />
          </div>
        )}
      </div>

      <div className="new-insurance-option-description text-start">
        {t('insuranceManagementTodo.confirmation.addDesc')}
      </div>
    </div>
  );
};

export default NewInsuranceOption;
